import React, { Fragment } from 'react';
import { Link } from 'react-static';

import BlogPostTiles from './BlogPostTiles';
import Carousel from './Carousel';
import Footer from './Footer';
import Header from './Header';
import LanguageSelect from './LanguageSelect';
import DownloadLinks from './DownloadLinks'
import Waves from './Waves';

import * as AceService from '../services/AceService';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import androidImg from '../images/android.svg'

export const HomeScreen = ({
  lang,
  rootUrl,
  articlesData,
  videosData,
  t,
  fetchMoreArticles,
  fetchMoreVideos,
}) => (
  <Fragment>
    <div className="top-block">
      <Header>
        <a
          className="header--menu--link hide_mobile"
          href={`${process.env.GRC_URL}/rules?locale=${lang}`}
          target="_blank"
        >
          {t('header.rewardPlan')}
        </a>
        <Link className="header--menu--link hide_mobile" to={`${rootUrl}faq`}>
          {t('header.faq')}
        </Link>
        <span
          className="header--menu--link"
          onClick={() => AceService.signIn(lang)}
        >
          {t('header.login')}
        </span>
        <div className="header--menu--link language-selector">
          <LanguageSelect
            name="lang"
            id="lang"
            value={lang}
            options={[
              { value: 'en', label: 'EN' },
              { value: 'zh-CN', label: '中文' },
            ]}
          />
        </div>
        <span
          className="button type_yellow hide_mobile hide_tablet_small"
          onClick={() => AceService.signUp(lang)}
        >
          {t('header.register')}
        </span>
      </Header>

      <div className="grid content-wrap grid-row top-block__about">
        <div className="grid-item xs-6 top-block__about--text">
          <h1>{t('widgets.top.header')}</h1>
          <h4>{t('widgets.top.content')}</h4>
          <span
            className="button type_yellow button_type_register size_l"
            onClick={() => AceService.signUp(lang)}
          >
            {t('header.register')}
          </span>
        </div>
        <div className="grid-item xs-6 top-block__about--videos">
          {videosData.items && (
            <Carousel
              t={t}
              data={videosData}
              fetchMoreVideos={fetchMoreVideos}
            />
          )}
        </div>
      </div>

      <Waves style={{ bottom: 0 }} waves={3} />

      {articlesData.items && <a href="#posts" className="button-next" />}
    </div>

    {articlesData.items && (
      <BlogPostTiles
        id="posts"
        lang={lang}
        data={articlesData}
        t={t}
        fetchMoreArticles={fetchMoreArticles}
      />
    )}

    <div className="how-it-works" id="how-it-works">
      <div className="grid wave-header">
        <Waves style={{ top: -72 }} flip waves={3} />
        <h2>{t('widgets.howItWorks.header')}</h2>
        <Waves style={{ bottom: -42 }} waves={1} shift />
      </div>
      <div className="grid content-wrap how-it-works--steps">
        <div className="grid-item center column step">
          <div className="step--circle type_card" />
          <div className="step--content">
            <h3>{t('widgets.howItWorks.step1.header')}</h3>
            <p>{t('widgets.howItWorks.step1.content')}</p>
          </div>
        </div>
        <div className="grid-item center column step">
          <div className="step--circle type_watch" />
          <div className="step--content">
            <h3>{t('widgets.howItWorks.step2.header')}</h3>
            <p>{t('widgets.howItWorks.step2.content')}</p>
          </div>
        </div>
        <div className="grid-item center column step">
          <div className="step--circle type_discount" />
          <div className="step--content">
            <h3>{t('widgets.howItWorks.step3.header')}</h3>
            <p>{t('widgets.howItWorks.step3.content')}</p>
          </div>
        </div>
      </div>
    </div>
    <div className="grid-item center column app-section">
      <div className="center">
        <DownloadLinks
          title={t('widgets.downloadLinks.header')}
          links={[
            {
              icon: androidImg,
              text: t('widgets.downloadLinks.android'),
              href: process.env.REACT_APP_DOWNLOAD_MOBILE_APP_ENDPOINT}]
            }
          />
      </div>
    </div>
    <div className="content-wrap">
      <div className="bottom-line" />
    </div>
    <Footer t={t} />
  </Fragment>
);

export default HomeScreen;



// WEBPACK FOOTER //
// /app/apps/ms/src/components/HomeScreen.js